<p-dialog [(visible)]="display"
          [closable]="false"
          [styleClass]="dialogClass + ' ' + extraCssClass"
          [style]="_style"
          position="center"
          [closeOnEscape]="true"
          [focusOnShow]="true"
          [dismissableMask]="true"
          [modal]="true"
          [draggable]="draggable"
          [contentStyle]="_contentStyle"
          [appendTo]="appendTo">
  <p-header>
    <ng-container *ngTemplateOutlet="headerTpl">
    </ng-container>
  </p-header>
  @if (renderBody) {
    <ng-container *ngTemplateOutlet="bodyTpl">
    </ng-container>
  }
  <p-footer>
    <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  </p-footer>
</p-dialog>
